<template>
  <div>
    <b-list-group-item v-for="(item,index) in compartments" :key="index" class="d-flex flex-column  m-0" href="#">
      <p class="m-0 h6">{{ item.Name }}</p>
      <div class="compartments-wrap">
        <span class="compartment-input-wrap">
          <p class="m-0">{{$t('DeliveredCompartments')}}</p>
          <vue-number-input :id="'compartmentDelivered'+index" class="compartment-input" :step="1" :min="0" inline controls :value="0" pattern="[0-9]*" @change="updateCompartmentDeliveredQuantity(item, $event)"></vue-number-input>
        </span>
        <span class="compartment-input-wrap">
          <p class="m-0">{{$t('LoadedCompartments')}}</p>
          <vue-number-input :id="'compartmentLoaded'+index" class="compartment-input" :step="1" :min="0" inline controls :value="0" pattern="[0-9]*" @change="updateCompartmentLoadedQuantity(item, $event)"></vue-number-input>
        </span>
      </div>
    </b-list-group-item>
    <div class="text-center mt-3">
      <b-button type="button" class="mr-3" @click="onClose()" variant="danger">{{$t('Back')}}</b-button>
      <b-button type="button" @click="onSubmit()" variant="success">{{$t('Send')}}</b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CompartmentsList",
  props: {
    shipmentId: {
      required: true,
      type: Number,
    },
    compartments: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
    };
  },
  watch: {
    isOnline: function (val) {
      if (!val)
        this.$root.$children[0].$refs.requestToats.makeToast('warning', 'no internet connection', 'You are using app in offline mode');
      }
  },
  computed: {
    ...mapGetters(["getPostCompartmentsStatus"]),
    loading: function () {
      return this.authStatus === "loading" || this.ordersListStatus === "loading";
    }
  },
  methods: {
    onClose() {
      this.$emit('submitCompartments', false);
    },
    onSubmit() {
      this.$emit('submitCompartments', true);
    },
    updateCompartmentLoadedQuantity(item, count) {
      item.loaded = count;
    },
    updateCompartmentDeliveredQuantity(item, count) {
      item.delivered = count;
    },
  }
};
</script>

<style >
  .compartment-input {
    width: fit-content;
  }
  .compartments-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }
</style>